import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Star } from 'lucide-react';
const items = [{
  title: '2x1: Mazo de cartas españolas + Mazo de "UNO" Scaloneta',
  desc: 'Los dos mazos completos en un solo pack. Cartas españolas para el truco y UNO edición Scaloneta para la juntada. Todo listo para imprimir y cortar.'
}, {
  title: 'Diseño de reverso exclusivo',
  desc: 'Con el escudo y las ★★★ estrellas. Para que cuando estén sobre la mesa, se vea que este mazo no es cualquiera.'
}, {
  title: 'Guía de impresión en 3 pasos',
  desc: 'Sin complicaciones. Desde el archivo hasta las cartas en tu mano en menos de una hora.'
}];
export function OfferStack() {
  return <section id="offer" className="py-10 px-4 bg-navy-800 relative" data-id="element-178">
      <div className="max-w-3xl mx-auto" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-180">
          <h2 className="text-5xl md:text-6xl font-bebas text-white mb-4" data-id="element-181">
            ¿Qué recibís exactamente?
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-182" />
        </motion.div>

        <div className="space-y-4" data-id="element-183">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex gap-4 p-6 rounded-xl bg-navy-900 border border-white/5 hover:border-gold/30 transition-colors group" data-id="element-184">
              <div className="flex-shrink-0 mt-1" data-id="element-185">
                <CheckCircle2 className={`w-6 h-6 group-hover:scale-110 transition-transform ${(item as any).free ? 'text-green-400' : 'text-gold'}`} data-id="element-186" />
              </div>
              <div data-id="element-187">
                <h4 className="text-xl font-semibold text-white mb-2 flex items-center gap-2 flex-wrap" data-id="element-188">
                  {item.title}
                  {(item as any).free && <span className="text-xs bg-green-500/20 text-green-400 px-2 py-0.5 rounded font-bold uppercase" data-id="element-189">
                      GRATIS
                    </span>}
                </h4>
                <p className="text-white/70 leading-relaxed" data-id="element-190">{item.desc}</p>
              </div>
            </motion.div>)}

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="relative mt-8 p-1 rounded-xl bg-gradient-to-r from-gold/50 via-gold to-gold/50" data-id="element-191">
            <div className="flex gap-4 p-6 rounded-lg bg-navy-900 h-full w-full" data-id="element-192">
              <div className="flex-shrink-0 mt-1" data-id="element-193">
                <Star className="w-6 h-6 text-gold fill-gold" data-id="element-194" />
              </div>
              <div data-id="element-195">
                <div className="inline-block px-2 py-1 bg-green-500/20 text-green-400 text-xs font-bold tracking-wider rounded mb-2 uppercase" data-id="element-196">
                  🎁 Gratis con tu compra
                </div>
                <h4 className="text-xl font-semibold text-white mb-2" data-id="element-197">
                  Anotador de puntaje "Scaloneta"
                </h4>
                <p className="text-white/70 leading-relaxed" data-id="element-198">
                  Olvidate del contador del celular que te consume toda la
                  batería y se apaga en el mejor momento. Este anotador
                  imprimible va directo a la mesa, no necesita WiFi, no se queda
                  sin pila y le suma onda a cada partida.
                </p>
                <div className="relative mt-4 w-full max-w-sm aspect-square rounded-xl overflow-hidden" data-id="element-199">
                  <img src="https://cdn.magicpatterns.com/uploads/mQSKfGwgMhWQxrQwQjJksF/fe3c81b7-39c6-49dd-bea7-6ab983064dc7.png" alt="Anotador de puntaje Scaloneta" className="w-full h-full object-cover" data-id="element-200" />
                  <div className="absolute top-3 right-3 bg-green-500 text-white text-xs font-bold px-3 py-1.5 rounded-lg uppercase shadow-lg" data-id="element-201">
                    GRATIS
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="relative mt-4 p-1 rounded-xl bg-gradient-to-r from-gold/50 via-gold to-gold/50" data-id="element-202">
            <div className="flex gap-4 p-6 rounded-lg bg-navy-900 h-full w-full" data-id="element-203">
              <div className="flex-shrink-0 mt-1" data-id="element-204">
                <Star className="w-6 h-6 text-gold fill-gold" data-id="element-205" />
              </div>
              <div data-id="element-206">
                <div className="inline-block px-2 py-1 bg-green-500/20 text-green-400 text-xs font-bold tracking-wider rounded mb-2 uppercase" data-id="element-207">
                  🎁 Gratis con tu compra
                </div>
                <h4 className="text-xl font-semibold text-white mb-2" data-id="element-208">
                  Tablero para torneos de Truco y UNO
                </h4>
                <p className="text-white/70 leading-relaxed" data-id="element-209">
                  Armá tu propio torneo con bracket incluido. Anotá equipos,
                  cruces y resultados como si fuera la Copa del Mundo. Perfecto
                  para el asado, la juntada o el after del partido. Imprimilo,
                  colgalo en la pared y que empiece la competencia.
                </p>
                <div className="relative mt-4 w-full max-w-sm aspect-square rounded-xl overflow-hidden" data-id="element-210">
                  <img src="https://cdn.magicpatterns.com/uploads/1F6cJ79cU7AuSkz5VZePWb/3b6f29d8-eace-4a53-9379-b348d66138e1.png" alt="Tablero para torneos de Truco y UNO" className="w-full h-full object-cover" data-id="element-211" />
                  <div className="absolute top-3 right-3 bg-green-500 text-white text-xs font-bold px-3 py-1.5 rounded-lg uppercase shadow-lg" data-id="element-212">
                    GRATIS
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}